var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 1.875C13.6785 1.875 13.9583 2.15482 13.9583 2.5V3.54168H15C16.2656 3.54168 17.2916 4.56769 17.2916 5.83334V9.16668V15.8333C17.2916 17.099 16.2656 18.125 15 18.125H4.99998C3.73433 18.125 2.70831 17.099 2.70831 15.8333V9.16668V5.83334C2.70831 4.56769 3.73433 3.54168 4.99998 3.54168H6.04165V2.5C6.04165 2.15482 6.32147 1.875 6.66665 1.875C7.01183 1.875 7.29165 2.15482 7.29165 2.5V3.54168H12.7083V2.5C12.7083 2.15482 12.9881 1.875 13.3333 1.875ZM16.0416 5.83334V8.54168H3.95831V5.83334C3.95831 5.25805 4.42468 4.79168 4.99998 4.79168H6.04165V5.83333C6.04165 6.17851 6.32147 6.45833 6.66665 6.45833C7.01183 6.45833 7.29165 6.17851 7.29165 5.83333V4.79168H12.7083V5.83333C12.7083 6.17851 12.9881 6.45833 13.3333 6.45833C13.6785 6.45833 13.9583 6.17851 13.9583 5.83333V4.79168H15C15.5753 4.79168 16.0416 5.25805 16.0416 5.83334ZM16.0416 9.79168H3.95831V15.8333C3.95831 16.4086 4.42468 16.875 4.99998 16.875H15C15.5753 16.875 16.0416 16.4086 16.0416 15.8333V9.79168ZM6.66665 11.875C6.32147 11.875 6.04165 12.1548 6.04165 12.5V14.1667C6.04165 14.5118 6.32147 14.7917 6.66665 14.7917H8.33332C8.6785 14.7917 8.95832 14.5118 8.95832 14.1667V12.5C8.95832 12.1548 8.6785 11.875 8.33332 11.875H6.66665Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4.34894,
    y1: 4.92188,
    x2: 15.4935,
    y2: 5.80885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3C2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.18f1e6bfbb84e74de5c0bacca05456cb.svg";
export { ForwardRef as ReactComponent };